import { Box, Snackbar, Alert } from '@mui/material';
import { LoadingSkeleton, TableTitleBox, TableBodySkeleton } from '../../common/components';
import FireInsuranceHeader from './components/FireInsuranceHeader';
import FireInsuranceTable from './components/FireInsuranceTable';
import FireInsurancePagination from './components/FireInsurancePagination';
import FireInsuranceImportDialog from './components/FireInsuranceImportDialog';
import { useFireInsurance } from './hooks/useFireInsurance';

/**
 * Componente principal para gestionar seguros de incendio
 * Incluye funcionalidad de exportar e importar
 */
const FireInsurance = () => {
  const {
    // Data de la tabla
    data,
    isLoading,
    page,
    totalPages,
    totalCount,
    rowsPerPage,
    filter,
    plans,
    groups,

    // Funciones de tabla
    handleFilter,
    handlePageChange,
    handleRowsPerPageChange,
    handleDownloadExcel,

    // Estados de importación
    selectedFile,
    tableData,
    importDialogOpen,
    importLoading,
    snackbar,

    // Funciones de importación
    handleFileUpload,
    handleImportValues,
    handleCloseImportDialog,
    handleUpload,
    handleCloseSnackbar,
  } = useFireInsurance();

  return (
    <Box>
      <TableTitleBox title="Contrato | Seguro de incendio" />

      {/* Header con filtros, exportar e importar */}
      <FireInsuranceHeader
        filter={filter}
        plans={plans}
        groups={groups}
        onFilter={handleFilter}
        onDownloadExcel={handleDownloadExcel}
        isLoading={isLoading}
        selectedFile={selectedFile}
        onFileUpload={handleFileUpload}
        onImportValues={handleImportValues}
      />

      {/* Tabla de datos */}
      <FireInsuranceTable data={data} isLoading={isLoading} LoadingComponent={TableBodySkeleton} />

      {/* Paginación */}
      <FireInsurancePagination
        totalPages={totalPages}
        totalCount={totalCount}
        page={page}
        onPageChange={handlePageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      {/* Modal de confirmación de importación */}
      <FireInsuranceImportDialog
        open={importDialogOpen}
        onClose={handleCloseImportDialog}
        tableData={tableData}
        loading={importLoading}
        onUpload={handleUpload}
      />

      {/* Snackbar para notificaciones */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default FireInsurance;
